import React, { FC } from 'react';

import { Modal as AntdModal } from 'antd';
import { IModalProps } from './interfaces';

const Modal: FC<IModalProps> = ({ withDefaultButtons, children, ...props }) => {
  return (
    <AntdModal
      okButtonProps={{ style: { display: 'none' } }}
      cancelButtonProps={{ style: { display: 'none' } }}
      footer={false}
      {...props}
    >
      {children}
    </AntdModal>
  );
};

export default Modal;
